import React, { Component } from 'react';

import Links from '../Tools/links';
import Carousel from '../Tools/Carousel';

class ChoirHigh extends Component {
  state = {
    imageList: [
      {
        img:
          'https://res.cloudinary.com/dwvrok1le/image/upload/v1547231111/red.jpg',
        school: 'Red Oak High School',
      },
      {
        img:
          'https://www.duncanvilleisd.org/cms/lib6/TX01917816/Centricity/Domain/4/Region%20Choir%20Students.png',
        school: 'Duncanville High School',
      },
      {
        img:
          'https://res.cloudinary.com/dwvrok1le/image/upload/v1547231209/irving.jpg',
        school: 'Irving High School',
      },
    ],
  };
  render() {
    const { files } = this.props;
    return (
      <div className="band_high scroll">
        <h2 className="band_title">High School</h2>
        <Carousel imageList={this.state.imageList} />
        <div className="band_high_sub">
          <div className="band_high_left">
            <div>
              <h3>Solo & Ensemble</h3>
              <Links input={files.solo} />
            </div>
            <div>
              <h3>Concert / Sightreading</h3>
              <Links input={files.concert} />
            </div>
          </div>
          <div className="border_line" />
          <div>
            <h3>Contest Schedules</h3>
            <Links input={files.schedules} />
          </div>
        </div>
      </div>
    );
  }
}

export default ChoirHigh;



// WEBPACK FOOTER //
// ./src/Components/Choir/ChoirHigh.js